const ExposedSidesLayout = ({ exposedSides }) => {
  const sideSymbol = {
    Left: "L",
    Right: "R",
    Top: "T",
    Bottom: "B",
    Back: "b",
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {["Left", "Right", "Top", "Bottom", "Back"]
        .filter((side) => exposedSides.includes(side))
        .map((side, index) => (
          <div
            className="d-flex justify-content-center align-items-center me-1"
            key={index}
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              border: "1px solid black",
            }}
          >
            {sideSymbol[side]}
          </div>
        ))}
    </div>
  );
};
export default ExposedSidesLayout;
